import { HiverAxios } from 'h-signup'
import { 
    USER_DETAILS,
	USER_DETAILS_FAILURE,
    SIGNUP_USERSESSION
} from './types';

const signupUsersession = (new URLSearchParams(window.location.search).get('usersession'));
if(signupUsersession) localStorage.setItem(SIGNUP_USERSESSION, signupUsersession);

const FETCH_INIT = '/api/signup/get-details';

function fetchUserDetails() {
    return (dispatch) => {
        HiverAxios({
            url: FETCH_INIT,
            type: 'GET',
            callback: (response) => {
				response = response.data
                dispatch({
                    type: USER_DETAILS,
                    payload: { 
						renderAccName: response.account_name_required,
						avatarUrl: response.avatar_url,
						firstName: response.first_name,
						email: response.email,
                        lastName: response.last_name,
                        id: response.user_id,
                        inviterName: response.inviter_name
					}
                });
            },
            onfail: () => {
				dispatch({
                    type: USER_DETAILS_FAILURE,
                    payload: { 
                        submitError: { status: 'fail' }, 
                        submitInProgress: false 
                    }
                });
            }
        })
    }
}

export default fetchUserDetails;